import Model from "../classes/Model";
import Api from "../classes/api/Cashflow";
import ValidationError from "../classes/ValidationError";
import ClientSubscription from "./ClientSubscription";
import Trainer from "./Trainer";
import Client from "./Client";
import Good from "./Good";
import Subscription from "./Subscription";
import User from "./User";

export default class Cashflow extends Model {

    get id() {
        return this._id;
    }
    set id(value) {
        this._id = value;
    }

    get typeId() {
        return this._typeId;
    }
    set typeId(value) {
        this._typeId = value;
    }

    get linkId() {
        return this._linkId;
    }
    set linkId(value) {
        this._linkId = value;
    }

    get clientSubscriptionId() {
        return this._clientSubscriptionId;
    }
    set clientSubscriptionId(value) {
        this._clientSubscriptionId = value;
    }

    get peopleId() {
        return this._peopleId;
    }
    set peopleId(value) {
        this._peopleId = value;
    }

    get flow() {
        return this._flow;
    }
    set flow(value) {
        this._flow = value;
    }

    get sum() {
        return this._sum;
    }
    set sum(value) {
        this._sum = value;
    }

    get sumIn() {
        return this._sumIn;
    }
    set sumIn(value) {
        this._sumIn = value;
    }

    get discount() {
        return this._discount;
    }
    set discount(value) {
        this._discount = value;
    }

    get sumChange() {
        return this._sumChange;
    }
    set sumChange(value) {
        this._sumChange = value;
    }

    get paymentType() {
        return this._paymentType;
    }
    set paymentType(value) {
        this._paymentType = value;
    }

    set comment(value) {
        this._comment = value;
    }
    get comment() {
        return this._comment;
    }

    get link() {
        return this._link;
    }
    set link(value) {
        this._link = value;
    }

    get clientSubscription() {
        return this._clientSubscription;
    }
    set clientSubscription(value) {
        this._clientSubscription = value;
    }

    get people() {
        return this._people;
    }
    set people(value) {
        this._people = value;
    }

    get creator() {
        return this._creator;
    }
    set creator(value) {
        this._creator = value;
    }


    get createdAt() {
        return this._createdAt;
    }
    set createdAt(value) {
        this._createdAt = value;
    }
    get createdBy() {
        return this._createdBy;
    }
    set createdBy(value) {
        this._createdBy = value;
    }

    static get FLOW_GAIN() { return 1; }
    static get FLOW_LESS() { return 2; }

    static get PAYMENT_TYPE_CASH() { return 1; }
    static get PAYMENT_TYPE_CARD() { return 2; }

    static get TYPE_OTHER() { return 0; }
    static get TYPE_GAIN_SALE_SUBSCRIPTION() { return 6; }
    static get TYPE_GAIN_SALE_GOOD() { return 7; }
    static get TYPE_GAIN_CLOSE_DEBT() { return 8; }
    static get TYPE_GAIN_SURCHARGE() { return 9; }
    static get TYPE_LESS_CHANGE() { return 1; }
    static get TYPE_LESS_SALARY() { return 2; }
    static get TYPE_LESS_ADMINISTRATIVE_EXPENSES() { return 3; }
    static get TYPE_LESS_ADV() { return 4; }
    static get TYPE_LESS_COLLECTION() { return 5; }
    static get TYPE_LESS_PERSONAL_TRAINING() { return 11; }
    static get TYPE_LESS_RETURN() { return 12; }

    static getTypesFlow() {
        return [
            {id: Cashflow.FLOW_GAIN, name: 'Внесение'},
            {id: Cashflow.FLOW_LESS, name: 'Изъятие'},
        ];
    }

    static getTypesPayment() {
        return [
            {id: Cashflow.PAYMENT_TYPE_CASH, name: 'Наличные'},
            {id: Cashflow.PAYMENT_TYPE_CARD, name: 'Безнал'},
        ];
    }
    static getTypesGain() {
        return [
            {id: Cashflow.TYPE_GAIN_SALE_SUBSCRIPTION, name: 'Продажа абонемента'},
            {id: Cashflow.TYPE_GAIN_SALE_GOOD, name: 'Продажа товара'},
            {id: Cashflow.TYPE_GAIN_CLOSE_DEBT, name: 'Закрытие долга'},
            {id: Cashflow.TYPE_GAIN_SURCHARGE, name: 'Доплата'},
        ];
    }

    static getTypesLess() {
        return [
            {id: Cashflow.TYPE_LESS_CHANGE, name: 'Замена'},
            {id: Cashflow.TYPE_LESS_SALARY, name: 'Оплата труда'},
            {id: Cashflow.TYPE_LESS_ADMINISTRATIVE_EXPENSES, name: 'Хозяйственные расходы'},
            {id: Cashflow.TYPE_LESS_ADV, name: 'Реклама'},
            {id: Cashflow.TYPE_LESS_COLLECTION, name: 'Инкассация'},
            {id: Cashflow.TYPE_LESS_PERSONAL_TRAINING, name: 'Персональная тренировка'},
            {id: Cashflow.TYPE_LESS_RETURN, name: 'Возврат'},
        ];
    }

    static getTypes() {
        return [...Cashflow.getTypesGain(), ...Cashflow.getTypesLess()];
    }

    constructor (config) {
        super();

        for (let field in config) {
            if (config.hasOwnProperty(field) === false) {
                continue;
            }
            this[`_${field}`] = config[field];
        }
    }



    toRequest() {
        return {
            id: this.id,
            type_id: this.typeId,
            link_id: this.linkId,
            client_subscription_id: this.clientSubscriptionId,
            people_id: this.peopleId,
            flow: this.flow,
            sum: this.sum,
            payment_type: this.paymentType,
            comment: this.comment,
        };
    }

    static toResponse(data) {
        let link = null, clientSubscription = null, people = null, creator = null;
        if (undefined !== data.link && data.link) {
            if (Number(data.type_id) === Cashflow.TYPE_GAIN_SALE_SUBSCRIPTION) {
                link = new Subscription(Subscription.toResponse(data.link));
            }
            if (Number(data.type_id) === Cashflow.TYPE_GAIN_SURCHARGE) {
                link = new Subscription(Subscription.toResponse(data.link));
            }
            if (Number(data.type_id) === Cashflow.TYPE_GAIN_CLOSE_DEBT) {
                link = new Subscription(Subscription.toResponse(data.link));
            }
            if (Number(data.type_id) === Cashflow.TYPE_GAIN_SALE_GOOD) {
                link = new Good(Good.toResponse(data.link));
            }
        }

        if (undefined !== data.people && data.people) {
            if (Number(data.type_id) === Cashflow.TYPE_GAIN_SALE_SUBSCRIPTION) {
                people = new Client(Client.toResponse(data.people));
            }
            if (Number(data.type_id) === Cashflow.TYPE_GAIN_SALE_GOOD) {
                people = new Client(Client.toResponse(data.people));
            }
            if (Number(data.type_id) === Cashflow.TYPE_GAIN_SURCHARGE) {
                people = new Client(Client.toResponse(data.people));
            }
            if (Number(data.type_id) === Cashflow.TYPE_GAIN_CLOSE_DEBT) {
                people = new Client(Client.toResponse(data.people));
            }
            if (Number(data.type_id) === Cashflow.TYPE_LESS_CHANGE) {
                people = new Trainer(Trainer.toResponse(data.people));
            }
            if (Number(data.type_id) === Cashflow.TYPE_LESS_SALARY) {
                if(data.people_id === data.link_id) {
                    people = new User(User.toResponse(data.people));
                } else {
                    people = new Trainer(Trainer.toResponse(data.people));
                }
            }
            if (Number(data.type_id) === Cashflow.TYPE_LESS_PERSONAL_TRAINING) {
                if(data.people_id === data.link_id) {
                    people = new User(User.toResponse(data.people));
                } else {
                    people = new Trainer(Trainer.toResponse(data.people));
                }
            }
            if (Number(data.type_id) === Cashflow.TYPE_LESS_RETURN) {
                people = new User(User.toResponse(data.people));
            }
            if (Number(data.type_id) === Cashflow.TYPE_LESS_ADMINISTRATIVE_EXPENSES) {
                people = new User(User.toResponse(data.people));
            }
            if (Number(data.type_id) === Cashflow.TYPE_LESS_ADV) {
                people = new User(User.toResponse(data.people));
            }
            if (Number(data.type_id) === Cashflow.TYPE_LESS_COLLECTION) {
                people = new User(User.toResponse(data.people));
            }
        }

        if (undefined !== data.clientSubscription && data.clientSubscription) {
            clientSubscription = new ClientSubscription(ClientSubscription.toResponse(data.clientSubscription));
        }
        if (undefined !== data.creator && data.creator) {
            creator = new User(User.toResponse(data.creator));
        }
        return {
            id: data.id,
            typeId: data.type_id,
            linkId: data.link_id,
            clientSubscriptionId: data.client_subscription_id,
            peopleId: data.people_id,
            flow: data.flow,
            sum: data.sum,
            sumIn: data.sum_in ? data.sum_in : 0,
            discount: data.discount ? data.discount : 0,
            sumChange: data.sum_change ? data.sum_change : 0,
            paymentType: data.payment_type,
            comment: data.comment,
            link: link,
            clientSubscription: clientSubscription,
            people: people,
            creator: creator,
            createdAt: data.created_at,
            createdBy: data.created_by,
        };
    }

    static getList(page = 1, perPage = 10, sort = undefined, extraFields = undefined, flow = undefined) {
        return Api.getList(page, perPage, sort, extraFields, flow).then((response) => {
            let data = [];
            for (let group of response.data) {
                data.push(new this(this.toResponse(group)));
            }
            return {data, headers: response.headers};
        });
    }

    static get(id) {
        return Api.get(id).then(({data}) => {
            let fields = this.toResponse(data);
            fields.id = Number(id);
            return new this(fields);
        });
    }


    add() {
        let request = this.toRequest();
        return Api.add(request).then(({data}) => {
            if (data.success === false) {
                throw new ValidationError(data.errors);
            }
            request.id = Number(data.id);
            return new Cashflow(request);
        });
    }

    update() {
        if (!this.id) {
            throw new Error('id not set');
        }
        let request = this.toRequest();
        return Api.update(request).then(({data}) => {
            if (data.success === false) {
                throw new ValidationError(data.errors);
            }
            return true;
        })
    }

    remove() {
        if (!this.id) {
            throw new Error('id not set');
        }
        return Api.remove(this.id).then(({data}) => {
            return data.success;
        });
    }

    static updateSum(id, newSum) {
        return Api.updateSum(id, newSum).then(({data}) => {
            return data.success;
        });
    }

}
